export default __webpack_public_path__ + "static/media/home_phone.3f337ff3.svg";